import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-language-icon',
  imports: [NgClass],
  templateUrl: './language-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './language-icon.component.scss',
})
export class LanguageIconComponent {
  @Input() public size = 6;
}
